import { Box, Button, Typography, useTheme } from '@mui/material';
import FilterIcon from '../../icons/FilterIcon';
import { KeyboardArrowDown } from '@mui/icons-material';

/**
 * FilterBtn
 *
 * A custom button component for opening the filter menu with icon and customizable styles.
 *
 * @param {function} handleClick - Function to handle button click events.
 * @param {string} text - Text displayed on the button.
 * @param {object} sx - Custom styles for the button.
 *
 * @returns {JSX.Element} - Styled button with filter and dropdown icons.
 */

export const FilterBtn = ({ handleClick, text = 'Filter', sx = {}, ...props }) => {
    const theme = useTheme();

    return (
        <Button
            onClick={handleClick}
            sx={{
                padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.medium}`,
                borderRadius: theme.typography.borderRadius.xSmall,
                border: `1px solid ${theme.palette.grey[300]}`,
                color: theme.palette.text.secondary,
                background: theme.palette.background.default,
                fontSize: theme.typography.customFontSize.small,
                fontWeight: theme.typography.fontWeightSemiBold,
                justifyContent: 'start',

                '& .MuiSvgIcon-root': {
                    color: theme.palette.icon.neutralSecondary,
                },

                '&:hover': {
                    color: theme.palette.text.secondary,
                    background: theme.palette.background.default,
                },

                ...sx,
            }}
            // startIcon={<FilterIcon />}
            endIcon={<KeyboardArrowDown />}
            {...props}
        >
            <Typography component={'p'} variant="paraText3" flex={1} display={'flex'} justifyContent={'start'} alignItems={'center'} lineHeight={'100%'}>
                {text}
            </Typography>
        </Button>
    );
};
